import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { DocumentViewer } from '@stereograph/teia-system-design/components/DocumentViewer';
import { Icon } from '@stereograph/teia-system-design/components/Icon';
import { CircularProgress } from '@stereograph/teia-system-design/components/Progress';
import { Stack } from '@stereograph/teia-system-design/components/Stack';
import { Text } from '@stereograph/teia-system-design/components/Typography';
import { usePluginTranslation } from '@translation';
import { useAnomalyDocumentContext } from '../../context/AnomalyDocumentContext';
import { useGetAttachmentBlob } from '../../hooks/useGetAttachmentBlob';
import { getMimeType } from '../../utils/useGetMimeType';

export const AnomalyDocumentVisualizer = () => {
  const { anomalyDocument } = useAnomalyDocumentContext();
  const { t } = usePluginTranslation();
  const { data: blob, isLoading } = useGetAttachmentBlob(anomalyDocument);
  const mimeType = getMimeType(anomalyDocument.title);

  if (isLoading) {
    return (
      <Stack
        direction="row"
        spacing={4}
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '100%',
          height: '200px',
        }}
      >
        <CircularProgress />
        <Text variant="body2">{t('anomaly_plugin.widget.visualize.loading.text')}</Text>
      </Stack>
    );
  }

  if (!mimeType || !blob) {
    return (
      <Stack
        spacing={4}
        direction="row"
        alignItems="center"
        sx={{
          width: '100%',
          height: '100px',
        }}
      >
        <Icon
          component={ExclamationTriangleIcon}
          sx={{
            color: 'error.main',
          }}
        />
        <Text variant="body2">{t('anomaly_plugin.widget.visualize.error.text')}</Text>
      </Stack>
    );
  }

  return (
    <Stack sx={{
      minWidth: '100%',
      maxHeight: '100%',
    }}
    >
      <DocumentViewer
        fileType={mimeType}
        filePath={blob}
        audioViewerProps={{}}
        imageViewerProps={{
          alt: anomalyDocument.title,
        }}
        pdfViewerProps={{
          className: 'pdf-viewer',
          title: 'PDF Viewer',
          style: {
            flexGrow: 1,
            minHeight: '80vh',
          },
        }}
        videoViewerProps={{
          videoProps: {
            style: {
              height: '100%',
            },
          },
        }}
      />
    </Stack>
  );
};
